<template>
  <el-row>
    <h2>View Admins List by Division</h2>
    <el-row :gutter="24">
      <el-col :lg="6">
        Division:  <all-division-dropdown v-model="divisionId" :inputModel="divisionId"></all-division-dropdown>
      </el-col>
      <el-col :span="4">
        <el-button type="warning" class="searchBtn" @click="clear()">Clear Options</el-button>
      </el-col>
    </el-row>

    <br /><br />
    <el-col :span="24">
      <h3>Division Admins</h3>
      <transition name="panel">
        <div class="pea-panel rules-panel">
          <el-table :data="divisionEntriesList" @current-change="selectRow" class="allApproversTable" v-loading="tableLoading">
            <el-table-column prop="userName" align="left"
                             label="User Name" sortable>
            </el-table-column>
            <el-table-column prop="fullName" align="left"
                             label="User Full Name" sortable>
            </el-table-column>
            <el-table-column prop="divisionName" align="left"
                             label="Division Name">
            </el-table-column>
            <el-table-column prop="canView" align="left"
                             label="Can View?" sortable>
                             <template slot-scope="scope">
                                 <p v-if="scope.row.canView">Yes</p>
                                 <p v-if="!scope.row.canView">No</p>
                              </template>
            </el-table-column>
            <el-table-column prop="isAdmin" align="left"
                             label="Admin?" sortable>
                             <template slot-scope="scope">
                                 <p v-if="scope.row.isAdmin">Yes</p>
                                 <p v-if="!scope.row.isAdmin">No</p>
                              </template>
            </el-table-column>
          </el-table>
        </div>
      </transition>
    </el-col>
  </el-row>
</template>
<script>
import helperMethods from '@/components/utility/helperMethods.js'
import router from '@/router'
export default {
  name: 'viewAdminsByDivision',
  data () {
    return {
      divisionEntriesList: [],
      divisionId: '',
      resultTotal: 0,
      column: 'Level',
      order: 'Ascending',
      tableLoading: true
    }
  },
  methods: {
    selectRow: function (row) {
      if (this.$store.getters.isAdmin || this.$store.getters.isServiceDesk) {
        router.push('adminDivisionAccess/' + row.userName)
      }
    },
    search () {
      this.tableLoading = true
      var tempDiv = this.divisionId
      if (this.divisionId === '' || this.divisionId === null) {
        tempDiv = 0
      }
      var call = '/getAdminsListByDivision/' + tempDiv
      this.$axios.get(call).then(response => {
        this.divisionEntriesList = response.data
        this.resultTotal = response.data.length
        this.tableLoading = false
      }).catch(reject => {
        this.tableLoading = false
        this.tableData = null
        this.resultTotal = 0
        helperMethods.showNotification(this, 'Error Retrieving Admins and Viewers list', reject.body, 'error', 30000)
      })
    },
    clear () {
      this.divisionId = ''
    }
  },
  mounted () {
    this.search()
  },
  watch: {
    divisionId: function () {
      this.search()
    }
  }
}
</script>

<style scoped>
  h4 {
    margin-bottom: 20px;
  }

  .rules-panel {
    padding-bottom: 30px;
  }
</style>
<style>
  .allApproversTable tr:hover {
    cursor: pointer;
  }
</style>
